module.exports = __webpack_public_path__ + "static/media/smart-goals.f78495a7.png";